export const COLOR_DEFAULT = 'default';
export const COLOR_PRIMARY = 'primary';
export const COLOR_SECONDARY = 'secondary';
export const COLOR_SUCCESS = 'success';
export const COLOR_INFO = 'info';
export const COLOR_WARNING = 'warning';
export const COLOR_ALERT = 'alert';
export const COLOR_GRAY_BASE = 'grayBase';
export const COLOR_GRAY_DARKER = 'grayDarker';
export const COLOR_GRAY_DARK = 'grayDark';
export const COLOR_GRAY = 'gray';
export const COLOR_GRAY_LIGHT = 'grayLight';
export const COLOR_GRAY_LIGHTER = 'grayLighter';
export const COLOR_RED = 'red';
export const COLOR_ORANGE = 'orange';
export const COLOR_YELLOW = 'yellow';
export const COLOR_GREEN = 'green';
export const COLOR_BLUE = 'blue';
export const COLOR_PURPLE = 'purple';
